module.exports = __webpack_public_path__ + "static/media/mari_desktop2.728b8ed7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mari/mari_desktop2.png
// module id = 91
// module chunks = 0